import { render, staticRenderFns } from "./WheelOfFortune.vue?vue&type=template&id=049883be&scoped=true&"
import script from "./WheelOfFortune.vue?vue&type=script&lang=js&"
export * from "./WheelOfFortune.vue?vue&type=script&lang=js&"
import style0 from "./WheelOfFortune.vue?vue&type=style&index=0&id=049883be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049883be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
